import {
  IGetRedirectDTO,
  ICreateRedirectDTO,
  IDeleteRedirectDTO,
  IUpdateRedirectDTO,
  IGetRedirectResponse,
  IGetRedirectsDTO,
  IGetRedirectsResponse,
  RedirectsEndpoints,
} from '@/models/redirects.model';
import { ApiResponse, httpClient } from '@/utils';

class RedirectsAPI {
  static getRedirects(data: IGetRedirectsDTO): ApiResponse<IGetRedirectsResponse> {
    return httpClient.get<IGetRedirectsResponse>(RedirectsEndpoints.REDIRECTS, { params: data });
  }

  static getRedirect(data: IGetRedirectDTO): ApiResponse<IGetRedirectResponse> {
    return httpClient.get<IGetRedirectResponse>(`${RedirectsEndpoints.REDIRECTS}/${data.id}`);
  }

  static createRedirect(data: ICreateRedirectDTO): ApiResponse<IGetRedirectResponse> {
    return httpClient.post<IGetRedirectResponse>(RedirectsEndpoints.REDIRECTS, data);
  }

  static updateRedirect({ id, ...data }: IUpdateRedirectDTO): ApiResponse<IGetRedirectResponse> {
    return httpClient.put<IGetRedirectResponse>(`${RedirectsEndpoints.REDIRECTS}/${id}`, data);
  }

  static deleteRedirect(data: IDeleteRedirectDTO): ApiResponse<void> {
    return httpClient.delete<void>(`${RedirectsEndpoints.REDIRECTS}/${data.id}`);
  }
}

export default RedirectsAPI;
